export const fallbackURL = process.env.REACT_APP_ACCESO_URL.trim();